import { Trans } from "@web-monorepo/i18n/macro";
import { DDSDisplayText, DDSHeadlineText } from "@web-monorepo/dds";
import { clsx } from "clsx";
import { useEffect, useState } from "react";
import { formatTime } from "utils";
import styles from "./CountdownTime.module.css";

type CountdownTimeProps = {
  seconds: number;
};

const BLINK_INTERVAL_MS = 500;

export default function CountdownTime({ seconds }: CountdownTimeProps) {
  const [displayZero, setDisplayZero] = useState(true);
  const isExpired = seconds <= 0;

  useEffect(() => {
    if (!isExpired) return;
    const handle = setInterval(() => {
      setDisplayZero((prev) => !prev);
    }, BLINK_INTERVAL_MS);
    return () => clearInterval(handle);
  }, [isExpired]);

  if (!isExpired) {
    return (
      <div className={styles.runningContainer}>
        {/* Numeric "M:SS" countdown — not natural-language copy, so opt out of auto-translation. */}
        <DDSDisplayText>{formatTime(seconds)}</DDSDisplayText>
      </div>
    );
  }

  // The 0 below blinks between content-danger (red) and content-light (white,
  // invisible against the light card background) to create the "Time's up!"
  // pulse. Preserves the pre-migration `kind="danger" | "light"` dance via CSS
  // classes. The literal "0" stays as plain text — when this branch renders,
  // the parent has already clamped `seconds` to 0.
  return (
    <div className={styles.expiredContainer}>
      <DDSHeadlineText as="h2" level="md">
        <Trans>Time's up!</Trans>
      </DDSHeadlineText>
      <DDSDisplayText className={clsx(styles.blinkZero, displayZero ? styles.danger : styles.light)}>0</DDSDisplayText>
    </div>
  );
}
